import { motion } from "framer-motion";

const PORTRAIT = "/photo-founder.jpg";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export const About = () => (
  <section id="about" className="relative py-28 lg:py-40" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16 items-center">
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        className="lg:col-span-5 relative"
      >
        <div className="relative">
          <div className="absolute -top-5 -left-5 w-full h-full border border-[#D4AF37]/40 pointer-events-none" />
          <div className="relative overflow-hidden">
            <motion.img
              src={PORTRAIT}
              alt="Adina Howard, Founder of SHE Global™ Institute, in a black pinstripe suit and red collared shirt."
              className="w-full aspect-[4/5] object-cover"
              data-testid="about-portrait"
              whileHover={{ scale: 1.03 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            />
          </div>
        </div>
        <div className="mt-6" data-testid="about-portrait-caption">
          <p className="font-serif-display text-2xl text-[#D4AF37]" data-testid="about-portrait-name">Adina Howard</p>
          <p className="text-[0.65rem] tracking-[0.35em] uppercase text-white/70 mt-2" data-testid="about-portrait-title">Founder, SHE Global™ Institute</p>
        </div>
      </motion.div>

      <div className="lg:col-span-7 lg:pl-8">
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="text-[0.65rem] tracking-[0.4em] uppercase text-[#D4AF37] mb-6"
        >
          About the Institute
        </motion.p>
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F5F5F5]"
          data-testid="about-heading"
        >
          A new institution, built with <em className="italic text-[#D4AF37]">intent.</em>
        </motion.h2>
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="mt-8 space-y-6 text-base sm:text-lg leading-relaxed text-white max-w-2xl"
          data-testid="about-body"
        >
          <p>
            SHE Global™ Institute exists for a simple reason: too many capable women arrive at senior
            leadership without ever being taught how boardrooms actually work.
          </p>
        </motion.div>
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="gold-hairline mt-12 max-w-2xl"
        />
      </div>
    </div>
  </section>
);
